import { useEffect, useLayoutEffect, useRef } from "react";

// Priyanka's side sign: a watercolour cloth fixed flush to the left edge.
export function BrandBanner({ raised = false, onHome }) {
  const name = useRef(null);
  const sub = useRef(null);
  useEffect(() => {
    document.documentElement.classList.add("has-banner");
    return () => document.documentElement.classList.remove("has-banner");
  }, []);
  useLayoutEffect(() => {
    const fit = () => {
      const s = sub.current, n = name.current;
      if (!s || !n) return;
      s.style.letterSpacing = "0px";
      s.style.marginBottom = "0px";
      const gaps = s.textContent.length - 1;
      const extra = Math.max(0, (n.getBoundingClientRect().height - s.getBoundingClientRect().height) / gaps);
      s.style.letterSpacing = `${extra}px`;
      s.style.marginBottom = `-${extra}px`;
    };
    fit();
    document.fonts?.ready.then(fit);
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);
  const Tag = onHome ? "button" : "div";
  return (
    <Tag
      data-testid="brand-banner"
      data-home={onHome ? "1" : "0"}
      aria-label={onHome ? "Rainbow by the Rain, home" : "Rainbow by the Rain, Virtual Experience Gallery"}
      role={onHome ? undefined : "img"}
      type={onHome ? "button" : undefined}
      onClick={onHome}
      className={`brand-banner fixed left-0 top-2 ${raised ? "z-[95]" : "z-[64]"} select-none p-0 sm:top-3 ${onHome ? "pointer-events-auto cursor-pointer transition-[filter] duration-200 hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#7E57C2]" : "pointer-events-none"}`}
    >
      <div
        className="flex h-[156px] w-[34px] items-start justify-center overflow-hidden rounded-r-[5px] bg-cover bg-center shadow-[2px_3px_10px_rgba(60,40,50,0.2)] sm:h-[246px] sm:w-[48px]"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ""}/brand/cloth.jpg)` }}
      >
        <div className="mt-[10px] flex rotate-180 flex-col items-center gap-[2px] text-[#2E2A55] [writing-mode:vertical-rl] sm:mt-4 sm:gap-[3px]">
          <span ref={name} data-testid="brand-banner-name" className="whitespace-nowrap font-script text-[13px] leading-[1.1] sm:text-[22px]">
            Rainbow by the Rain
          </span>
          <span ref={sub} data-testid="brand-banner-subtitle" className="whitespace-nowrap font-display text-[7px] font-semibold uppercase leading-none text-[#7A746F] sm:text-[8.5px]">
            Virtual Experience Gallery
          </span>
        </div>
      </div>
    </Tag>
  );
}
